import logo from '@/pages/img/exato_logo.jpeg';


export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ background: '#f7f7f7' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src={logo}
              alt="EXATO Cálculos Trabalhistas"
              className="h-16 object-contain mb-4"
            />
            <p className="text-sm leading-relaxed max-w-xs" style={{ color: "#0E233C" }}>
              Referência em cálculos trabalhistas com inteligência artificial. Precisão, agilidade e segurança jurídica para advogados e escritórios.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-instagram-line', 'ri-linkedin-box-line', 'ri-whatsapp-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/10 text-white/50 hover:text-white hover:border-white/30 transition-all duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className=" text-sm font-semibold mb-4" style={{ color: "#0E233C" }}>Navegação</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Sobre', id: 'sobre' },
                { label: 'Diferenciais', id: 'diferenciais' },
                { label: 'Curso', id: 'curso' },
                { label: 'Plataforma', id: 'plataforma' },
                { label: 'Contato', id: 'contato' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    style={{ color: "#0E233C" }}
                    className="text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold mb-4" style={{ color: "#0E233C" }}>Serviços</h4>
            <ul className="space-y-2.5">
              {[
                'Liquidação de Sentença',
                'Embargos à Execução',
                'Impugnações',
                'Atualização de Cálculos',
                'Plataforma de Gestão',
              ].map((s) => (
                <li key={s}>
                  <span className=" text-sm" style={{ color: "#0E233C" }}>{s}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs" style={{ color: "#0E233C" }}>
            © {new Date().getFullYear()} Exato Cálculos Trabalhistas. Todos os direitos reservados.
          </p>
          <p className="text-xs" style={{ color: "#0E233C" }}>
            Desenvolvido por M2F Soluções Web · São Paulo, Brasil
          </p>
        </div>
      </div>
    </footer>
  );
}
